(() => {
  'use strict';

  if (customElements.get('meb-navigation')) return;
  customElements.define('meb-navigation', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const root = this;
      const on = (node, event, listener) => node?.addEventListener(event, listener, { signal });
      const imageAssets = JSON.parse(root.querySelector('[data-nav-images]').textContent);
      let ownsScrollLock = false;
      const lockScroll = () => {
        if (!document.body.classList.contains('overflow-hidden')) {
          document.body.classList.add('overflow-hidden');
          ownsScrollLock = true;
        }
      };
      this.unlockScroll = () => {
        if (ownsScrollLock) document.body.classList.remove('overflow-hidden');
        ownsScrollLock = false;
      };
      // Lucide icon nodes, extracted at build time. No runtime library request.
  const icons = {
    Menu: [['path', { d: 'M4 5h16' }], ['path', { d: 'M4 12h16' }], ['path', { d: 'M4 19h16' }]],
    Search: [['path', { d: 'm21 21-4.34-4.34' }], ['circle', { cx: 11, cy: 11, r: 8 }]],
    UserRound: [['circle', { cx: 12, cy: 8, r: 5 }], ['path', { d: 'M20 21a8 8 0 0 0-16 0' }]],
    ShoppingBag: [['path', { d: 'M16 10a4 4 0 0 1-8 0' }], ['path', { d: 'M3.103 6.034h17.794' }], ['path', { d: 'M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z' }]],
    ChevronDown: [['path', { d: 'm6 9 6 6 6-6' }]],
    X: [['path', { d: 'M18 6 6 18' }], ['path', { d: 'm6 6 12 12' }]],
    ArrowLeft: [['path', { d: 'm12 19-7-7 7-7' }], ['path', { d: 'M19 12H5' }]],
    ArrowRight: [['path', { d: 'M5 12h14' }], ['path', { d: 'm12 5 7 7-7 7' }]],
    ArrowUpRight: [['path', { d: 'M7 7h10v10' }], ['path', { d: 'M7 17 17 7' }]]
  };
  const ns = 'http://www.w3.org/2000/svg';
  const icon = name => {
    const svg = document.createElementNS(ns, 'svg');
    Object.entries({ viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'aria-hidden': 'true', focusable: 'false' }).forEach(([key, value]) => svg.setAttribute(key, value));
    icons[name].forEach(([tag, attrs]) => {
      const node = document.createElementNS(ns, tag);
      Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
      svg.append(node);
    });
    return svg;
  };
  root.querySelectorAll('[data-icon]').forEach(node => node.replaceChildren(icon(node.dataset.icon)));

  const store = root.dataset.root.replace(/\/$/, '');
  const collection = '/collections/';
  const file = 'https://www.motoebikes.com/cdn/shop/files/';
  const cdn = 'https://cdn.shopify.com/s/files/1/0710/9181/4709/collections/';
  const item = (label, route, image, alt, responsive = false) => ({ label, route, image, alt, responsive });
  const bikes = [
    item('Road-Legal Electric Motorbikes', collection + 'road-legal-electric-motorbikes', file + 'LiveWireMullhollandperformance.webp?v=1781030813', 'LiveWire S2 Mulholland being ridden on a road', true),
    item('Off-Road Electric Motorbikes', collection + 'off-road-electric-motorbikes', 'https://assets.starkfuture.com/frontend-assets/ex-product/hero_01_desktop.webp', 'Stark VARG EX rider on an off-road trail'),
    item('Kids Electric Bikes', collection + 'kids-junior-electric-dirt-bikes', cdn + 'revvi-kids-riding-gear-hero.webp?v=1789546415', 'Young REVVI rider wearing riding protection', true),
    item('Used and Demo Bikes', collection + 'used-electric-motorbikes', file + 'used-2025-sur-ron-ultra-bee-x-1.jpg?v=1790759500', 'Pre-owned Sur-Ron Ultra Bee X at MotoEbikes', true)
  ];
  const secondary = [
    item('All Electric Motorbikes', collection + 'all-electric-motorbikes', 'https://escooterclinic.co.uk/hpeciai/da699d2c60e7758eac8db4c2f451a551/eng_pl_Talaria-Komodo-Electric-Motorcycle-32000W-Power-45Ah-Battery-66mph-Speed-72mi-Range-TL6000-8824_6.webp', 'Talaria Komodo rider on a dirt trail'),
    item('Compare Bikes', '/pages/electric-motorbike-comparisons', file + 'IMG_1676.webp?v=1785615198', 'Several electric motorbikes together in the MotoEbikes showroom', true)
  ];
  const brands = [
    item('Stark Future', collection + 'stark-electric-motorcycles', 'https://mcn-images.bauersecure.com/wp-images/303788/951x634/stark_varg_ex__8_.jpg?mode=max&quality=90&scale=down', 'Stark VARG EX riding through water'),
    item('LiveWire', collection + 'livewire-electric-motorcycles', 'https://images.bikeexif.com/2024/03/2024-livewire-s2-mulholland-10.jpg?v=1753735045', 'LiveWire S2 Mulholland rider on a city street'),
    item('Sur-Ron', collection + 'sur-ron-electric-bikes', 'https://sur-ron.co.uk/wp-content/themes/surron/assets/img/lbx-3.jpg', 'Sur-Ron Light Bee X being ridden on a rocky trail'),
    item('Talaria', collection + 'talaria-electric-bikes', 'https://konto.chip.pl/uploads/2026/01/elektryczny-motocykl-enduro-talaria-komodo-6.jpg', 'Talaria Komodo rider crossing logs'),
    item('Zero', collection + 'zero-electric-motorcycles', 'https://www.zeromotorcycles.fi/var/brandt/storage/images/media/elvis/zero-motorcycles/zero-models/zero-dsr-my24/zero-motorcycles-my24-dsr-action-2/6196118-1-fin-FI/zero-motorcycles-my24-dsr-action-2_reference.jpg', 'Zero DSR rider on the road'),
    item('RFN', collection + 'rfn-electric-bikes', 'https://rfnbike.com.au/cdn/shop/files/029A0183-3copy_3d76683e-f436-4c70-8c2d-5d88686f8a38.jpg?v=1773123349', 'RFN rider cornering on a dirt track', true),
    item('REVVI', '/pages/revvi-electric-bikes-uk', 'https://www.revvi.co.uk/wp-content/uploads/sites/3/2026/02/5F_X6S6J_XA-HD.jpg', 'Young rider on a REVVI electric balance bike')
  ];
  const parts = [
    item('All Parts and Accessories', collection + 'electric-bike-parts-accessories', cdn + 'Electric_motorcycle_bike_parts_and_accessories.webp?v=1789068689', 'Electric motorbike parts and accessories', true),
    item('REVVI Parts and Accessories', collection + 'revvi-parts-accessories-uk', cdn + 'mseo_63773227483509_1770653772592.webp?v=1789738276', 'REVVI electric bike parts and accessories', true),
    item('REVVI Riding Gear and Protection', collection + 'revvi-riding-gear-protection-uk', cdn + 'revvi-kids-riding-gear-hero.webp?v=1789546415', 'REVVI rider wearing a helmet and protective riding gear', true)
  ];

  const advice = [
    item('Road Legal Guide', '/pages/road-legal-electric-motorbikes'),
    item('Licence Guide', '/pages/electric-motorbike-licence-guide'),
    item('Charging Guide', '/pages/electric-motorbike-charging-guide'),
    item('New Riders', '/pages/new-riders-guide'),
    item('Understanding Range', '/pages/electric-motorbike-range'),
    item('Can I Ride on a CBT?', '/pages/electric-motorbike-licence-guide'),
    item('Reviews', '/pages/electric-motorcycle-reviews'),
    item('Advice Centre', '/blogs/advice-centre')
  ];
  const explore = [
    item('New Arrivals', collection + 'new-electric-motorbikes'),
    item('Bestsellers', collection + 'best-selling-electric-motorbikes'),
    item('Special Offers', collection + 'electric-motorbike-special-offers'),
    item('Beginner Friendly', collection + 'beginner-friendly-electric-motorbikes'),
    item('Commuting Bikes', collection + 'commuting-electric-motorbikes'),
    item('Longer Range Bikes', collection + 'longer-range-electric-motorbikes')
  ];
  const menuTitle = menu => ({ bikes: 'Shop Bikes', parts: 'Parts', advice: 'Advice Centre' })[menu];

  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const link = (route, className) => {
    const anchor = element('a', className);
    anchor.href = store + route;
    return anchor;
  };
  const photoLink = (entry, compact = false) => {
    const anchor = link(entry.route, compact ? 'secondary-link' : 'photo-link');
    const frame = element('span', 'photo-frame');
    const image = element('img');
    image.width = 640;
    image.height = 360;
    image.alt = entry.alt;
    image.fetchPriority = 'low';
    image.loading = 'lazy';
    image.decoding = 'async';
    image.sizes = compact ? '(max-width: 1179px) 70px, 60px' : '(max-width: 480px) calc((100vw - 62px) / 2), (max-width: 1179px) 210px, ' + (brands.includes(entry) ? '15vw' : '24vw');
    if (imageAssets[entry.label]) {
      const sources = imageAssets[entry.label];
      image.srcset = sources.map(source => `${source.src} ${source.width}w`).join(', ');
      image.src = sources[sources.length - 1].src;
    } else if (entry.responsive) {
      const withWidth = width => {
        const url = new URL(entry.image);
        url.searchParams.set('width', width);
        return url.href;
      };
      image.srcset = [240, 400, 640].map(width => `${withWidth(width)} ${width}w`).join(', ');
      image.src = withWidth(640);
    } else {
      image.src = entry.image;
    }
    frame.append(image);
    anchor.append(frame);
    const label = element('strong', '', entry.label);
    if (compact) anchor.append(label, icon('ArrowRight'));
    else {
      const caption = element('span', 'photo-label');
      caption.append(label, icon('ArrowRight'));
      anchor.append(caption);
    }
    return anchor;
  };

  const desktop = root.querySelector('[data-nav-part="desktop-panel"]');
  const drawer = root.querySelector('[data-nav-part="mobile-drawer"]');
  const shade = root.querySelector('.page-shade');
  const mobileQuery = matchMedia('(max-width: 1179px)');
  const state = { desktop: { menu: 'bikes', view: 'riding' }, mobile: { menu: 'bikes', view: 'riding' } };
  let desktopTrigger;

  const textLink = entry => {
    const anchor = link(entry.route, 'menu-link');
    anchor.append(element('span', '', entry.label), icon('ArrowRight'));
    return anchor;
  };
  const heading = text => element('h3', 'group-heading', text);
  const list = (entries, className) => {
    const ul = element('ul', 'menu-list ' + className);
    entries.forEach(entry => {
      const li = element('li');
      li.append(textLink(entry));
      ul.append(li);
    });
    return ul;
  };
  const photos = (entries, className = '') => {
    const grid = element('div', 'photo-grid ' + className);
    entries.forEach(entry => grid.append(photoLink(entry)));
    return grid;
  };
  // Images are created only for the panel that the visitor opens.
  function render(scope) {
    const container = root.querySelector(`[data-nav-part="${scope}-content"]`);
    const menu = state[scope].menu;
    container.replaceChildren();
    if (menu === 'parts') {
      const section = element('section', 'parts-panel');
      section.append(heading('Parts and Accessories'), photos(parts, 'parts-grid'));
      container.append(section);
      return;
    }
    if (menu === 'advice') {
      const grid = element('div', 'advice-grid');
      grid.append(list(advice, 'advice-list'));
      const promo = element('aside', 'finance-promo');
      const img = element('img');
      const source = file + 'MotoEbikes_finance_advice_in_the_Guildford_electric_motorbike_showroom_mobile.webp';
      img.width = 640;
      img.height = 640;
      img.alt = 'Finance advice in the MotoEbikes Guildford showroom';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.sizes = '(max-width: 1179px) 320px, 290px';
      img.srcset = [320, 480, 640].map(width => source + '?width=' + width + ' ' + width + 'w').join(', ');
      img.src = source + '?width=640';
      const copy = element('div', 'finance-copy');
      const cta = link('/pages/electric-motorbike-finance-uk', '');
      cta.textContent = 'Explore finance options';
      copy.append(element('h3', '', 'Finance Available'), element('p', '', 'Spread the cost on selected electric motorbikes.'), cta);
      promo.append(img, copy);
      grid.append(promo);
      container.append(grid);
      return;
    }
    const grid = element('div', 'shop-grid');
    const mobile = scope === 'mobile';
    if (mobile) {
      const tabs = element('div', 'mobile-shop-tabs');
      tabs.setAttribute('role', 'tablist');
      tabs.setAttribute('aria-label', 'Browse bikes');
      for (const [view, label] of [['riding', 'By riding type'], ['brands', 'By brand']]) {
        const button = element('button', '', label);
        const selected = state.mobile.view === view;
        button.type = 'button';
        button.id = root.id + '-mobile-' + view + '-tab';
        button.dataset.shopView = view;
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', selected);
        button.setAttribute('aria-controls', root.id + '-mobile-bikes-grid');
        button.tabIndex = selected ? 0 : -1;
        const select = next => {
          state.mobile.view = next;
          render('mobile');
          root.querySelector('[data-shop-view="' + next + '"]').focus();
        };
        on(button, 'click', () => select(view));
        on(button, 'keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          select(event.key === 'Home' ? 'riding' : event.key === 'End' ? 'brands' : view === 'brands' ? 'riding' : 'brands');
        });
        tabs.append(button);
      }
      grid.id = root.id + '-mobile-bikes-grid';
      grid.setAttribute('role', 'tabpanel');
      grid.setAttribute('aria-labelledby', root.id + '-mobile-' + state.mobile.view + '-tab');
      container.append(tabs);
    }
    if (!mobile || state.mobile.view === 'brands') {
    const brandGroup = element('section', 'shop-brands');
    const orderedBrands = ['LiveWire', 'REVVI', 'RFN', 'Stark Future', 'Sur-Ron', 'Talaria', 'Zero'].map(name => brands.find(brand => brand.label === name));
    brandGroup.append(heading('Shop by Brand'), photos(orderedBrands, 'brand-grid'));
    grid.append(brandGroup);
    }
    if (!mobile || state.mobile.view === 'riding') {
    const riding = element('section', 'shop-riding');
    riding.append(heading('Shop by Riding Type'), photos(bikes, 'riding-grid'));
    const secondaryLinks = element('div', 'secondary-links');
    secondary.forEach(entry => secondaryLinks.append(photoLink(entry, true)));
    riding.append(secondaryLinks);
    const extra = element('section', 'subgroup');
    extra.append(heading('Explore'), list(explore, 'explore-list'));
    riding.append(extra);
    grid.append(riding);
    }
    container.append(grid);
  }

  function closeDesktop(restoreFocus = false) {
    desktop.hidden = true;
    shade.hidden = true;
    root.querySelectorAll('[data-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    root.querySelector('[data-nav-part="desktop-content"]').replaceChildren();
    if (restoreFocus) desktopTrigger?.focus();
  }
  function openDesktop(button) {
    if (!desktop.hidden && desktopTrigger === button) return closeDesktop();
    closeDesktop();
    desktopTrigger = button;
    state.desktop = { menu: button.dataset.open, view: 'riding' };
    const title = menuTitle(state.desktop.menu);
    root.querySelector('[data-nav-part="desktop-heading"]').textContent = title;
    desktop.setAttribute('aria-label', title);
    desktop.hidden = false;
    shade.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    desktop.style.maxHeight = `${Math.max(180, innerHeight - desktop.getBoundingClientRect().top)}px`;
    render('desktop');
  }
  root.querySelectorAll('[data-open]').forEach(button => {
    on(button, 'click', () => openDesktop(button));
    on(button, 'keydown', event => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (desktop.hidden || desktopTrigger !== button) openDesktop(button);
        desktop.querySelector('a')?.focus();
      }
    });
  });
  on(root.querySelector('[data-close-desktop]'), 'click', () => closeDesktop(true));
  on(shade, 'click', () => closeDesktop(true));
  on(document, 'keydown', event => {
    if (event.key === 'Escape' && !desktop.hidden) closeDesktop(true);
  });
  on(root.querySelector('#cart-icon-bubble'), 'click', () => closeDesktop());
  on(document, 'focusin', event => {
    if (!desktop.hidden && !desktop.contains(event.target) && !event.target.closest('[data-open]')) closeDesktop();
  });

  function mobileRoot(focus = false) {
    const previous = state.mobile.menu;
    drawer.classList.remove('is-submenu');
    root.querySelector('.mobile-root').hidden = false;
    root.querySelector('.mobile-submenu').hidden = true;
    root.querySelector('[data-mobile-back]').hidden = true;
    root.querySelector('[data-nav-part="mobile-heading"]').textContent = 'Menu';
    root.querySelector('[data-nav-part="mobile-content"]').replaceChildren();
    if (focus) drawer.querySelector(`[data-mobile-open="${previous}"]`)?.focus();
  }
  function openMobile() {
    closeDesktop();
    mobileRoot();
    drawer.showModal();
    lockScroll();
    root.querySelector('[data-open-mobile]').setAttribute('aria-expanded', 'true');
    drawer.querySelector('[data-mobile-open="bikes"]').focus();
  }
  function mobileSubmenu(menu) {
    state.mobile = { menu, view: 'riding' };
    drawer.classList.add('is-submenu');
    root.querySelector('.mobile-root').hidden = true;
    root.querySelector('.mobile-submenu').hidden = false;
    root.querySelector('[data-mobile-back]').hidden = false;
    root.querySelector('[data-nav-part="mobile-heading"]').textContent = menuTitle(menu);
    render('mobile');
    root.querySelector('.drawer-scroll').scrollTop = 0;
    root.querySelector('[data-mobile-back]').focus();
  }
  on(root.querySelector('[data-open-mobile]'), 'click', openMobile);
  on(root.querySelector('[data-close-mobile]'), 'click', () => drawer.close());
  on(root.querySelector('[data-mobile-back]'), 'click', () => mobileRoot(true));
  root.querySelectorAll('[data-mobile-open]').forEach(button => on(button, 'click', () => mobileSubmenu(button.dataset.mobileOpen)));
  on(drawer, 'close', () => {
    this.unlockScroll();
    root.querySelector('[data-open-mobile]').setAttribute('aria-expanded', 'false');
    mobileRoot();
    root.querySelector('[data-open-mobile]').focus();
  });
  on(drawer, 'click', event => { if (event.target === drawer && event.clientX > drawer.getBoundingClientRect().right) drawer.close(); });

  const search = root.querySelector('[data-nav-part="search-dialog"]');
  on(root.querySelector('[data-search]'), 'click', event => { event.preventDefault(); closeDesktop(); search.showModal(); lockScroll(); root.querySelector('[data-nav-part="search-input"]').focus(); });
  on(search, 'close', () => { this.unlockScroll(); root.querySelector('[data-search]')?.focus(); });
  on(search, 'keydown', event => {
    if (event.key === 'Escape') { event.preventDefault(); search.close(); }
  });
  on(root.querySelector('[data-close-search]'), 'click', () => search.close());
  on(search, 'click', event => {
    const box = search.getBoundingClientRect();
    if (event.target === search && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) search.close();
  });
  on(window, 'resize', () => { if (!desktop.hidden) desktop.style.maxHeight = `${Math.max(180, innerHeight - desktop.getBoundingClientRect().top)}px`; });
  on(window, 'scroll', () => { if (!desktop.hidden) closeDesktop(); });
  on(mobileQuery, 'change', () => { closeDesktop(); if (drawer.open) drawer.close(); });

      root.classList.add('is-ready');
      root.querySelectorAll('a[href]').forEach(anchor => {
        if (new URL(anchor.href, location.href).pathname === location.pathname) anchor.setAttribute('aria-current', 'page');
      });
    }
    disconnectedCallback() {
      this.unlockScroll?.();
      this.controller?.abort();
      this.controller = null;
    }
  });
})();
